import React from 'react';
import { observer } from 'mobx-react-lite';
import ManageAddEmployeesPageStore, {
  ManageAddEmployeesPageStoreContext,
} from 'store/pages/enrollment/manage-add-employees/pageStore';
import { PageContent } from 'components/enrollment/manage-add-employees';
import ProposalStatusLayout from 'components/common/proposal/ProposalStatusLayout';
import { useEnrollmentDomainParams } from 'global/hooks/useEnrollmentDomainParams';
import { PageWrapperStyled } from '../../../../globalStyles';

const ManageAddEmployeesPage: React.FC = observer(() => {
  const { periodId, groupId } = useEnrollmentDomainParams();

  return (
    <ManageAddEmployeesPageStoreContext.Provider value={new ManageAddEmployeesPageStore({ groupId, periodId })}>
      <ProposalStatusLayout>
        <PageWrapperStyled>
          <PageContent />
        </PageWrapperStyled>
      </ProposalStatusLayout>
    </ManageAddEmployeesPageStoreContext.Provider>
  );
});

export default ManageAddEmployeesPage;
